module.exports = __webpack_public_path__ + "static/media/sellador+adhesivo.173b741b.jpg";